// This file is auto-generated. Do not edit!

export const countries = {
    0: "BR",
    1: "CA",
    2: "CN",
    3: "DE",
    4: "GB",
    5: "IN",
    6: "NL",
    7: "US",
};

export const countries_rev = {
    "BR": 0,
    "CA": 1,
    "CN": 2,
    "DE": 3,
    "GB": 4,
    "IN": 5,
    "NL": 6,
    "US": 7,
};

export const currencies = {
    0: "BRL",
    1: "CAD",
    2: "CNY",
    3: "EUR",
    4: "GBP",
    5: "HKD",
    6: "INR",
    7: "NZD",
    8: "SEK",
    9: "SGD",
    10: "USD",
};

export const currencies_rev = {
    "BRL": 0,
    "CAD": 1,
    "CNY": 2,
    "EUR": 3,
    "GBP": 4,
    "HKD": 5,
    "INR": 6,
    "NZD": 7,
    "SEK": 8,
    "SGD": 9,
    "USD": 10,
};

export const exchanges = {
    0: "AMEX",
    1: "EURONEXT",
    2: "HKSE",
    3: "IOB",
    4: "LSE",
    5: "NASDAQ",
    6: "NSE",
    7: "NYSE",
    8: "SAO",
    9: "SHZ",
    10: "TSX",
    11: "XETRA",
};

export const exchanges_rev = {
    "AMEX": 0,
    "EURONEXT": 1,
    "HKSE": 2,
    "IOB": 3,
    "LSE": 4,
    "NASDAQ": 5,
    "NSE": 6,
    "NYSE": 7,
    "SAO": 8,
    "SHZ": 9,
    "TSX": 10,
    "XETRA": 11,
};

export const industries = {
    0: "Advertising Agencies",
    1: "Aerospace & Defense",
    2: "Agricultural Inputs",
    3: "Airlines",
    4: "Airports & Air Services",
    5: "Aluminum",
    6: "Apparel Manufacturing",
    7: "Apparel Retail",
    8: "Asset Management",
    9: "Auto & Truck Dealerships",
    10: "Auto Manufacturers",
    11: "Auto Parts",
    12: "Banks",
    13: "Banks—Diversified",
    14: "Banks—Regional",
    15: "Beverages—Brewers",
    16: "Beverages—Non-Alcoholic",
    17: "Beverages—Wineries & Distilleries",
    18: "Biotechnology",
    19: "Broadcasting",
    20: "Building Materials",
    21: "Building Products & Equipment",
    22: "Business Equipment & Supplies",
    23: "Capital Goods",
    24: "Capital Markets",
    25: "Chemicals",
    26: "Closed-End Fund - Equity",
    27: "Closed-End Fund - Foreign",
    28: "Coking Coal",
    29: "Commercial  & Professional Services",
    30: "Communication Equipment",
    31: "Communication Services",
    32: "Computer Hardware",
    33: "Confectioners",
    34: "Conglomerates",
    35: "Consulting Services",
    36: "Consumer Durables & Apparel",
    37: "Consumer Electronics",
    38: "Consumer Services",
    39: "Copper",
    40: "Credit Services",
    41: "Department Stores",
    42: "Diagnostics & Research",
    43: "Discount Stores",
    44: "Diversified Financials",
    45: "Diversified Machinery",
    46: "Drug Manufacturers—General",
    47: "Drug Manufacturers—Specialty & Generic",
    48: "Education & Training Services",
    49: "Electrical Equipment & Parts",
    50: "Electronic Components",
    51: "Electronic Gaming & Multimedia",
    52: "Electronics & Computer Distribution",
    53: "Energy",
    54: "Engineering & Construction",
    55: "Entertainment",
    56: "Farm & Heavy Construction Machinery",
    57: "Farm Products",
    58: "Financial Conglomerates",
    59: "Financial Data & Stock Exchanges",
    60: "Food & Staples Retailing",
    61: "Food Distribution",
    62: "Food, Beverage & Tobacco",
    63: "Footwear & Accessories",
    64: "Furnishings, Fixtures & Appliances",
    65: "Gambling",
    66: "General Building Materials",
    67: "Gold",
    68: "Grocery Stores",
    69: "Health Care Equipment & Services",
    70: "Health Information Services",
    71: "Healthcare Plans",
    72: "Home Improvement Retail",
    73: "Household & Personal Products",
    74: "Independent Oil & Gas",
    75: "Industrial Distribution",
    76: "Information Technology Services",
    77: "Infrastructure Operations",
    78: "Insurance",
    79: "Insurance Brokers",
    80: "Insurance Specialty",
    81: "Insurance—Diversified",
    82: "Insurance—Life",
    83: "Insurance—Property & Casualty",
    84: "Insurance—Reinsurance",
    85: "Insurance—Specialty",
    86: "Integrated Freight & Logistics",
    87: "Internet Content & Information",
    88: "Internet Retail",
    89: "Leisure",
    90: "Lodging",
    91: "Lumber & Wood Production",
    92: "Luxury Goods",
    93: "Marine Shipping",
    94: "Materials",
    95: "Media & Entertainment",
    96: "Medical Care Facilities",
    97: "Medical Devices",
    98: "Medical Distribution",
    99: "Medical Instruments & Supplies",
    100: "Metal Fabrication",
    101: "Mortgage Finance",
    102: "N/A",
    103: "Oil & Gas Drilling",
    104: "Oil & Gas E&P",
    105: "Oil & Gas Equipment & Services",
    106: "Oil & Gas Integrated",
    107: "Oil & Gas Midstream",
    108: "Oil & Gas Refining & Marketing",
    109: "Other Industrial Metals & Mining",
    110: "Other Precious Metals & Mining",
    111: "Packaged Foods",
    112: "Packaging & Containers",
    113: "Paper & Paper Products",
    114: "Personal Services",
    115: "Pharmaceutical Retailers",
    116: "Pollution & Treatment Controls",
    117: "Publishing",
    118: "REIT—Diversified",
    119: "REIT—Healthcare Facilities",
    120: "REIT—Hotel & Motel",
    121: "REIT—Industrial",
    122: "REIT—Mortgage",
    123: "REIT—Office",
    124: "REIT—Residential",
    125: "REIT—Retail",
    126: "REIT—Specialty",
    127: "Railroads",
    128: "Real Estate Services",
    129: "Real Estate—Development",
    130: "Real Estate—Diversified",
    131: "Recreational Vehicles",
    132: "Rental & Leasing Services",
    133: "Residential Construction",
    134: "Resorts & Casinos",
    135: "Restaurants",
    136: "Retail Apparel & Specialty",
    137: "Retailing",
    138: "Scientific & Technical Instruments",
    139: "Security & Protection Services",
    140: "Semiconductor Equipment & Materials",
    141: "Semiconductors",
    142: "Semiconductors & Semiconductor Equipment",
    143: "Shell Companies",
    144: "Silver",
    145: "Software & Services",
    146: "Software—Application",
    147: "Software—Infrastructure",
    148: "Specialty Business Services",
    149: "Specialty Chemicals",
    150: "Specialty Industrial Machinery",
    151: "Specialty Retail",
    152: "Staffing & Employment Services",
    153: "Steel",
    154: "Technology Hardware & Equipment",
    155: "Telecom Services",
    156: "Textile Manufacturing",
    157: "Thermal Coal",
    158: "Tobacco",
    159: "Tools & Accessories",
    160: "Transportation",
    161: "Travel Services",
    162: "Trucking",
    163: "Utilities",
    164: "Utilities Regulated",
    165: "Utilities—Diversified",
    166: "Utilities—Independent Power Producers",
    167: "Utilities—Regulated Electric",
    168: "Utilities—Regulated Gas",
    169: "Utilities—Regulated Water",
    170: "Utilities—Renewable",
    171: "Waste Management",
};

export const industries_rev = {
    "Advertising Agencies": 0,
    "Aerospace & Defense": 1,
    "Agricultural Inputs": 2,
    "Airlines": 3,
    "Airports & Air Services": 4,
    "Aluminum": 5,
    "Apparel Manufacturing": 6,
    "Apparel Retail": 7,
    "Asset Management": 8,
    "Auto & Truck Dealerships": 9,
    "Auto Manufacturers": 10,
    "Auto Parts": 11,
    "Banks": 12,
    "Banks—Diversified": 13,
    "Banks—Regional": 14,
    "Beverages—Brewers": 15,
    "Beverages—Non-Alcoholic": 16,
    "Beverages—Wineries & Distilleries": 17,
    "Biotechnology": 18,
    "Broadcasting": 19,
    "Building Materials": 20,
    "Building Products & Equipment": 21,
    "Business Equipment & Supplies": 22,
    "Capital Goods": 23,
    "Capital Markets": 24,
    "Chemicals": 25,
    "Closed-End Fund - Equity": 26,
    "Closed-End Fund - Foreign": 27,
    "Coking Coal": 28,
    "Commercial  & Professional Services": 29,
    "Communication Equipment": 30,
    "Communication Services": 31,
    "Computer Hardware": 32,
    "Confectioners": 33,
    "Conglomerates": 34,
    "Consulting Services": 35,
    "Consumer Durables & Apparel": 36,
    "Consumer Electronics": 37,
    "Consumer Services": 38,
    "Copper": 39,
    "Credit Services": 40,
    "Department Stores": 41,
    "Diagnostics & Research": 42,
    "Discount Stores": 43,
    "Diversified Financials": 44,
    "Diversified Machinery": 45,
    "Drug Manufacturers—General": 46,
    "Drug Manufacturers—Specialty & Generic": 47,
    "Education & Training Services": 48,
    "Electrical Equipment & Parts": 49,
    "Electronic Components": 50,
    "Electronic Gaming & Multimedia": 51,
    "Electronics & Computer Distribution": 52,
    "Energy": 53,
    "Engineering & Construction": 54,
    "Entertainment": 55,
    "Farm & Heavy Construction Machinery": 56,
    "Farm Products": 57,
    "Financial Conglomerates": 58,
    "Financial Data & Stock Exchanges": 59,
    "Food & Staples Retailing": 60,
    "Food Distribution": 61,
    "Food, Beverage & Tobacco": 62,
    "Footwear & Accessories": 63,
    "Furnishings, Fixtures & Appliances": 64,
    "Gambling": 65,
    "General Building Materials": 66,
    "Gold": 67,
    "Grocery Stores": 68,
    "Health Care Equipment & Services": 69,
    "Health Information Services": 70,
    "Healthcare Plans": 71,
    "Home Improvement Retail": 72,
    "Household & Personal Products": 73,
    "Independent Oil & Gas": 74,
    "Industrial Distribution": 75,
    "Information Technology Services": 76,
    "Infrastructure Operations": 77,
    "Insurance": 78,
    "Insurance Brokers": 79,
    "Insurance Specialty": 80,
    "Insurance—Diversified": 81,
    "Insurance—Life": 82,
    "Insurance—Property & Casualty": 83,
    "Insurance—Reinsurance": 84,
    "Insurance—Specialty": 85,
    "Integrated Freight & Logistics": 86,
    "Internet Content & Information": 87,
    "Internet Retail": 88,
    "Leisure": 89,
    "Lodging": 90,
    "Lumber & Wood Production": 91,
    "Luxury Goods": 92,
    "Marine Shipping": 93,
    "Materials": 94,
    "Media & Entertainment": 95,
    "Medical Care Facilities": 96,
    "Medical Devices": 97,
    "Medical Distribution": 98,
    "Medical Instruments & Supplies": 99,
    "Metal Fabrication": 100,
    "Mortgage Finance": 101,
    "N/A": 102,
    "Oil & Gas Drilling": 103,
    "Oil & Gas E&P": 104,
    "Oil & Gas Equipment & Services": 105,
    "Oil & Gas Integrated": 106,
    "Oil & Gas Midstream": 107,
    "Oil & Gas Refining & Marketing": 108,
    "Other Industrial Metals & Mining": 109,
    "Other Precious Metals & Mining": 110,
    "Packaged Foods": 111,
    "Packaging & Containers": 112,
    "Paper & Paper Products": 113,
    "Personal Services": 114,
    "Pharmaceutical Retailers": 115,
    "Pollution & Treatment Controls": 116,
    "Publishing": 117,
    "REIT—Diversified": 118,
    "REIT—Healthcare Facilities": 119,
    "REIT—Hotel & Motel": 120,
    "REIT—Industrial": 121,
    "REIT—Mortgage": 122,
    "REIT—Office": 123,
    "REIT—Residential": 124,
    "REIT—Retail": 125,
    "REIT—Specialty": 126,
    "Railroads": 127,
    "Real Estate Services": 128,
    "Real Estate—Development": 129,
    "Real Estate—Diversified": 130,
    "Recreational Vehicles": 131,
    "Rental & Leasing Services": 132,
    "Residential Construction": 133,
    "Resorts & Casinos": 134,
    "Restaurants": 135,
    "Retail Apparel & Specialty": 136,
    "Retailing": 137,
    "Scientific & Technical Instruments": 138,
    "Security & Protection Services": 139,
    "Semiconductor Equipment & Materials": 140,
    "Semiconductors": 141,
    "Semiconductors & Semiconductor Equipment": 142,
    "Shell Companies": 143,
    "Silver": 144,
    "Software & Services": 145,
    "Software—Application": 146,
    "Software—Infrastructure": 147,
    "Specialty Business Services": 148,
    "Specialty Chemicals": 149,
    "Specialty Industrial Machinery": 150,
    "Specialty Retail": 151,
    "Staffing & Employment Services": 152,
    "Steel": 153,
    "Technology Hardware & Equipment": 154,
    "Telecom Services": 155,
    "Textile Manufacturing": 156,
    "Thermal Coal": 157,
    "Tobacco": 158,
    "Tools & Accessories": 159,
    "Transportation": 160,
    "Travel Services": 161,
    "Trucking": 162,
    "Utilities": 163,
    "Utilities Regulated": 164,
    "Utilities—Diversified": 165,
    "Utilities—Independent Power Producers": 166,
    "Utilities—Regulated Electric": 167,
    "Utilities—Regulated Gas": 168,
    "Utilities—Regulated Water": 169,
    "Utilities—Renewable": 170,
    "Waste Management": 171,
};

export const sectors = {
    0: "Aerospace & Defense",
    1: "Auto Components",
    2: "Automobiles",
    3: "Banking",
    4: "Basic Materials",
    5: "Beverages",
    6: "Biotechnology",
    7: "Building",
    8: "Chemicals",
    9: "Commercial Services & Supplies",
    10: "Communication Services",
    11: "Construction",
    12: "Consumer Cyclical",
    13: "Consumer Defensive",
    14: "Consumer products",
    15: "Distributors",
    16: "Diversified Consumer Services",
    17: "Electrical Equipment",
    18: "Energy",
    19: "Financial Services",
    20: "Food Products",
    21: "Healthcare",
    22: "Hotels, Restaurants & Leisure",
    23: "Industrials",
    24: "Insurance",
    25: "Leisure Products",
    26: "Logistics & Transportation",
    27: "Machinery",
    28: "Marine",
    29: "Media",
    30: "Metals & Mining",
    31: "N/A",
    32: "Packaging",
    33: "Paper & Forest",
    34: "Pharmaceuticals",
    35: "Professional Services",
    36: "Real Estate",
    37: "Retail",
    38: "Road & Rail",
    39: "Semiconductors",
    40: "Technology",
    41: "Telecommunication",
    42: "Textiles, Apparel & Luxury Goods",
    43: "Tobacco",
    44: "Trading Companies & Distributors",
    45: "Utilities",
};

export const sectors_rev = {
    "Aerospace & Defense": 0,
    "Auto Components": 1,
    "Automobiles": 2,
    "Banking": 3,
    "Basic Materials": 4,
    "Beverages": 5,
    "Biotechnology": 6,
    "Building": 7,
    "Chemicals": 8,
    "Commercial Services & Supplies": 9,
    "Communication Services": 10,
    "Construction": 11,
    "Consumer Cyclical": 12,
    "Consumer Defensive": 13,
    "Consumer products": 14,
    "Distributors": 15,
    "Diversified Consumer Services": 16,
    "Electrical Equipment": 17,
    "Energy": 18,
    "Financial Services": 19,
    "Food Products": 20,
    "Healthcare": 21,
    "Hotels, Restaurants & Leisure": 22,
    "Industrials": 23,
    "Insurance": 24,
    "Leisure Products": 25,
    "Logistics & Transportation": 26,
    "Machinery": 27,
    "Marine": 28,
    "Media": 29,
    "Metals & Mining": 30,
    "N/A": 31,
    "Packaging": 32,
    "Paper & Forest": 33,
    "Pharmaceuticals": 34,
    "Professional Services": 35,
    "Real Estate": 36,
    "Retail": 37,
    "Road & Rail": 38,
    "Semiconductors": 39,
    "Technology": 40,
    "Telecommunication": 41,
    "Textiles, Apparel & Luxury Goods": 42,
    "Tobacco": 43,
    "Trading Companies & Distributors": 44,
    "Utilities": 45,
};

export const types = {
    0: "etf",
    1: "fund",
    2: "stock",
    3: "trust",
};

export const types_rev = {
    "etf": 0,
    "fund": 1,
    "stock": 2,
    "trust": 3,
};